/*
* Show Spacing X dropdown based on tab route or v-scored
*/
import React from 'react';
import SelectComponent from 'shared/components/SelectComponent';
import { spacingTabRouted, spacingVScored } from 'shared/data/selectOptions';
import {
  arraySpacingX as tooltipVScore,
  arraySpacingXTabRouted as tooltipTabRouted,
} from 'shared/data/tooltips';

const ArraySpacingXTV = (props) => {
  const {
    parameters,
    label,
    required,
    name,
    onChangeParameter,
    groupName,
  } = props;
  const selectedName = parameters.tab_rout === '1' ? 'array_spacing_x_tab_rout' : 'array_spacing_x_vscore';
  const onChange = e => onChangeParameter(selectedName, e.target.value);

  const spacingXTabRouted = (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={spacingTabRouted}
      tooltip={tooltipTabRouted}
      selected={parameters[selectedName] || ''}
      groupName={groupName} />);
  const spacingXVscore = (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={spacingVScored}
      tooltip={tooltipVScore}
      selected={parameters[selectedName] || ''}
      groupName={groupName} />);

  const Component = parameters.tab_rout === '1' ? spacingXTabRouted : spacingXVscore;

  return (
    <div>
      {Component}
    </div>
  );
};

ArraySpacingXTV.defaultProps = {
  label: 'Spacing in X',
  name: 'array_spacing_x',
  required: true,
  onChange: null,
  groupName: null,
};

export default ArraySpacingXTV;
